import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About 👀`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Currently: Live in Bình Thạnh, Ho Chi Minh city, Vietnam.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Familiar with many tools such as GitHub and Open-Sources group projects. Willing to learn through the Internship, currently looking for It relating Intern-Jobs to further enhance my skill and surfing through the experience.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`My core skills are JavaScript (Typescript), C# and SQL. I'm experienced in building web applications using Asp.net core.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`Resume:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://standardresume.co/r/tJP3KQFe9yUESofDI_xNs"
      }}><strong parentName="a">{`Ng. Gia Bao_2020`}</strong></a></p>
    <a href='https://standardresume.co/tech'>
  <img src='https://sindresorhus.com/assets/thanks/standard-resume-logo.svg' width='160' />
    </a>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      